import clsx from 'clsx';
import { ListCondition } from './ListCondition';

export interface LineConditionProps {
  progressContent?: string;
  percent?: number;
  content?: string;
  subConditions?: LineConditionProps[];
  isSubCondition?: boolean;
  isOR?: boolean;
  hideProgressBar?: boolean;
  disabled?: boolean;
}

export const LineCondition = ({
  disabled,
  percent,
  content,
  progressContent,
  subConditions,
  isSubCondition,
  isOR,
  hideProgressBar,
}: LineConditionProps) => {
  const isDone = !!percent && percent > 99;
  const isInProgress = !!percent && percent <= 99;
  const isUnActive = !percent;

  const displayConditionContent = !subConditions?.length && content;
  const displayBorder = !isSubCondition;
  const displayProgressBar = !hideProgressBar;

  return (
    <>
      {isOR && <p className="font-bold text-[16px] leading-[20px] first:hidden">HOẶC</p>}
      <div
        className={clsx('flex flex-col gap-2 w-full', [
          '[--inprogress-color:#FAAD14]',
          disabled ? '[--unactive-color:#8C8C8C]' : '[--unactive-color:#F5222D]',
          '[--done-color:var(--primary-color)]',
        ])}
      >
        <div className="flex items-center gap-2">
          {isUnActive && (
            <>
              <div className="h-4 w-4 rounded-full border-[2px] border-[var(--unactive-color)]" />
              <span className={clsx('text-[14px] leading-[17px] text-[var(--unactive-color)]')}>{progressContent}</span>
            </>
          )}
          {isInProgress && (
            <>
              <div className="h-4 w-4 rounded-full border-[2px] border-[var(--inprogress-color)]" />
              <span className="text-[var(--inprogress-color)] text-[14px] leading-[17px]">{progressContent}</span>
            </>
          )}
          {isDone && (
            <>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346639 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0822 16 8.5C16 6.37827 15.1571 4.34344 13.6569 2.84314C12.1566 1.34285 10.1217 0.5 8 0.5Z"
                  fill="var(--done-color)"
                />
                <path
                  d="M12.565 7.17498L7.75418 12.2253C7.62316 12.3629 7.46574 12.4726 7.29132 12.5479C7.1169 12.6232 6.92909 12.6625 6.73912 12.6635H6.733C6.54414 12.6634 6.3572 12.6255 6.18325 12.552C6.00929 12.4784 5.85187 12.3707 5.7203 12.2352L3.1683 9.60604C3.02951 9.47529 2.91865 9.31778 2.8424 9.14301C2.76615 8.96825 2.7261 8.77985 2.72465 8.58918C2.7232 8.39851 2.7604 8.20952 2.83398 8.03362C2.90757 7.85772 3.01603 7.69854 3.15282 7.5657C3.2896 7.43286 3.45188 7.32911 3.62986 7.2607C3.80784 7.19228 3.99783 7.16064 4.18838 7.16766C4.37892 7.17468 4.56607 7.22023 4.73853 7.30156C4.91099 7.38289 5.06519 7.49831 5.19183 7.64086L6.72124 9.21686L10.5184 5.2291C10.6462 5.09472 10.7992 4.98682 10.9686 4.91156C11.1381 4.8363 11.3207 4.79516 11.5061 4.79049C11.6915 4.78581 11.8759 4.81769 12.049 4.88431C12.222 4.95093 12.3803 5.05098 12.5146 5.17874C12.649 5.30651 12.7569 5.4595 12.8322 5.62897C12.9074 5.79844 12.9486 5.98107 12.9533 6.16643C12.9579 6.3518 12.9261 6.53628 12.8594 6.70932C12.7928 6.88237 12.6928 7.0406 12.565 7.17498Z"
                  fill="white"
                />
              </svg>
              <span className="text-[var(--done-color)] text-[14px] leading-[17px]">{progressContent}</span>
            </>
          )}
        </div>
        {displayProgressBar && (
          <div className="h-[6px] transition-all min-w-10 rounded-[10px] w-full bg-[#D9D9D9] overflow-hidden">
            <div
              style={{
                width: `${percent}%`,
              }}
              className={clsx('h-full', { 'bg-[var(--inprogress-color)]': isInProgress, 'bg-[var(--done-color)]': isDone })}
            />
          </div>
        )}
        <div className="flex gap-2 pl-2">
          {displayBorder && (
            <>
              {isUnActive && <div className="border-l-[1px] border-dashed border-[var(--unactive-color)]" />}
              {isInProgress && <div className="border-l-[1px] border-dashed border-[var(--inprogress-color)]" />}
              {isDone && <div className="border-l-[1px] border-[var(--done-color)]" />}
            </>
          )}
          {displayConditionContent && (
            <p
              className={clsx('font-[ggsr] text-[14px] leading-[22px] py-1', {
                'text-[var(--unactive-color)]': disabled,
              })}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
          <ListCondition conditions={subConditions} isSubCondition />
        </div>
      </div>
    </>
  );
};

